// extracted by mini-css-extract-plugin
export default {"error-text":"LoanDetails_error-text__jTb+j","main-wrapper":"LoanDetails_main-wrapper__OiuiH"};